import { ViewAll } from "./ViewAll";

export default ViewAll